module.exports = __webpack_public_path__ + "img/mkd.ed091b88.svg";